import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
import { Navigation } from './components/Navigation';
import { Dashboard } from './components/Dashboard';
import { WorkersPage } from './pages/WorkersPage';
import { InspectionsPage } from './pages/InspectionsPage';
import { DocumentsPage } from './pages/DocumentsPage';
import { BiltonAIPage } from './pages/BiltonAIPage';
import { PreShiftPage } from './pages/PreShiftPage';
import { ToolboxTalkPage } from './pages/ToolboxTalkPage';
import { JHAPage } from './pages/JHAPage';
import { PTPPage } from './pages/PTPPage';
import { ProjectFilterProvider } from './contexts/ProjectFilterContext';
import { ContractorFilterProvider } from './contexts/ContractorFilterContext';
import { BiltonAIProvider } from './contexts/BiltonAIContext';
import { KPIProvider } from './contexts/KPIContext';
import { PreventionModelProvider } from './contexts/PreventionModelContext';
// Layout wrapper for pages other than Dashboard (which handles its own layout now)
function PageLayout({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="min-h-screen bg-[#fafafa] flex" data-id="element-0" data-mp="3rd18nfm3z7mg">
      <Navigation data-id="element-1" data-mp="67yhm9c7y5s" />
      <div className="flex-1 flex flex-col min-w-0 h-screen overflow-hidden" data-id="element-2" data-mp="4n5i12o8na1">
        <main className="flex-1 overflow-y-auto overflow-x-hidden relative" data-id="element-3" data-mp="2zlv6yuqqp1v2">
          {children}
        </main>
      </div>
    </div>;
}
export function App() {
  return <BrowserRouter data-id="element-4" data-mp="38lrrqla0dgku">
      <ScrollToTop data-id="element-5" data-mp="38li9jjv7gdpp" />
      <BiltonAIProvider data-id="element-6" data-mp="38l053zye2t6p">
        <ProjectFilterProvider data-id="element-7" data-mp="38kgnylgkc8tq">
          <ContractorFilterProvider data-id="element-8" data-mp="3dkl4ucldv5kh">
            <KPIProvider data-id="element-9" data-mp="3dlnu6g324zya">
              <PreventionModelProvider data-id="element-10" data-mp="3dirv2ofh4589">
                <Routes data-id="element-11" data-mp="nw2a60hx7gog">
                  <Route path="/" element={<Dashboard data-id="element-13" data-mp="nvas7sh8xhgn" />} data-id="element-12" data-mp="nuhjilyq8hvv" />
                  <Route path="/bilton-ai" element={<PageLayout data-id="element-15" data-mp="36hvn4muyo06">
                        <BiltonAIPage data-id="element-16" data-mp="35gmj5pekbl3" />
                      </PageLayout>} data-id="element-14" data-mp="sudksdg1hv7q" />
                  <Route path="/workers" element={<PageLayout data-id="element-18" data-mp="d3cvbquvaug1">
                        <WorkersPage data-id="element-19" data-mp="d2bibguajxvo" />
                      </PageLayout>} data-id="element-17" data-mp="3ubzw6hji5vht" />
                  <Route path="/inspections" element={<PageLayout data-id="element-21" data-mp="3bmbehq4nwbke">
                        <InspectionsPage data-id="element-22" data-mp="3bn30qacdcwy0" />
                      </PageLayout>} data-id="element-20" data-mp="3gle88ef6yvd2" />
                  <Route path="/documents" element={<PageLayout data-id="element-24" data-mp="3ljpi2p5hl5va">
                        <DocumentsPage data-id="element-25" data-mp="3limryjfzn7gf" />
                      </PageLayout>} data-id="element-23" data-mp="3qbzf0p50r672" />
                  <Route path="/pre-shift" element={<PageLayout data-id="element-27" data-mp="18dri7slud9c8">
                        <PreShiftPage data-id="element-28" data-mp="18dhu6akcxc96" />
                      </PageLayout>} data-id="element-26" data-mp="2svtmjnrnlk03" />
                  <Route path="/toolbox-talk" element={<PageLayout data-id="element-30" data-mp="ygwkhbxe7cz0">
                        <ToolboxTalkPage data-id="element-31" data-mp="ydqvrxsoed3t" />
                      </PageLayout>} data-id="element-29" data-mp="1d59linbc7m0d" />
                  <Route path="/jha" element={<PageLayout data-id="element-33" data-mp="1r2fx9xxn8kg3">
                        <JHAPage data-id="element-34" data-mp="1w3lwmelt75yl" />
                      </PageLayout>} data-id="element-32" data-mp="1r4971m3jzksb" />
                  <Route path="/ptp" element={<PageLayout data-id="element-36" data-mp="1m4egxkrlqz8b">
                        <PTPPage data-id="element-37" data-mp="1m3cukk54yqba" />
                      </PageLayout>} data-id="element-35" data-mp="1i2j7fszipfjg" />
                </Routes>
              </PreventionModelProvider>
            </KPIProvider>
          </ContractorFilterProvider>
        </ProjectFilterProvider>
      </BiltonAIProvider>
    </BrowserRouter>;
}